import styled, { css } from 'styled-components';

export const ComparePlansDropdownStyled = styled.div.attrs(() => ({
  className: 'compare-plans-dropdown',
}))`
  ${({ theme }) => {
    const { media, colors } = theme;
    return css`
      &.compare-plans-dropdown {
        flex: 1;
        border-bottom: 1px solid ${colors.primary.neutralMedium};
        [class*='-indicatorContainer'] {
          padding-left: 4px;
          svg {
            width: 24px;
            height: 24px;
          }
        }

        [class*='-menu'] {
          margin-top: 1px;
        }

        [class*='-singleValue'] {
          margin: 0;
          overflow: visible;
          font-size: 18px;
          ${media.mobile.down} {
            font-size: 16px;
          }
          ${media.tablet.down} {
            font-size: 16px;
          }
        }
        [class*='placeholder'] {
          font-size: 18px;
          ${media.mobile.down} {
            font-size: 16px;
          }
          ${media.tablet.down} {
            font-size: 16px;
          }
        }
        [class*='-option'] {
          gap: 2px;
          font-size: 18px;
          height: 46px;
          padding: 16px;
          vertical-align: middle;
          border: 1px solid ${colors.primary.neutralLight};
          ${media.mobile.down} {
            height: 34px;
            padding: 8px;
            font-size: 14px;
          }
          ${media.tablet.down} {
            height: 34px;
            padding: 8px;
            font-size: 14px;
          }
        }
        [class*='-MenuList'] {
          padding-top: 0;
          padding-bottom: 0;
        }
      }
    `;
  }}
`;

export default ComparePlansDropdownStyled;
